import React from 'react';
import { PieChart, Pie, Tooltip, Cell } from 'recharts';
import { Row, Col } from 'antd';

class CustomTooltip extends React.Component {


  render() {

    const { percenInLabel } = this.props

    let payload = this.props.payload[0];
    if (!payload) {
      return null;
    }

    return (
      <div style={styles.toolTip} >
        <Row style={styles.tooltipContent}>
          <Col style={{
            backgroundColor: payload.payload.fill,
            border: '1px solid #FFFFFF',
            height: '16px',
            width: '16px',
            borderRadius: '50px',
            paddingLeft: '5px',
            marginTop: '10px'
          }}></Col>

          <Col style={styles.toolTipContent}>{payload.payload.name}</Col>
          <Col style={styles.toolTipContent}>{payload.payload.value.toFixed(0)}{percenInLabel && ' %'}</Col>
        </Row>

      </div>
    );
  }
}

class GraphDistribution extends React.Component {

  customLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.25;
    const RADIAN = Math.PI / 180;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    return (
      <text x={x} y={y} fill="#ffffff" textAnchor={x > cx ? 'start' : 'end'} style={{ fontSize: 15, fill: 'white' }} dominantBaseline="central">
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  }


  render() {
    const { percenInLabel } = this.props


    let { data, t, colors } = this.props
    if (data && t) {
      data = data.map(item => {
        return { name: t(item.name), value: item.value }
      })
    }
    
    return (
      <PieChart width={340} height={340} id="chart-distribution">
        <Pie
          isAnimationActive={false}
          data={data}
          innerRadius={90}
          outerRadius={160}
          fill="#8884d8"
          labelLine={false}
          label={this.customLabel}
        >
          {this.props.data.map((entry, index) => <Cell fill={colors[index % colors.length]} />)}
        </Pie>
        <Tooltip
          cursor={false}
          content={<CustomTooltip data={data} percenInLabel={percenInLabel} />}
          wrapperStyle={styles.wrapper}
          labelStyle={styles.label}
          itemStyle={styles.label}>
        </Tooltip>
      </PieChart>

    )
  }
}

// }
export default GraphDistribution;

// const colors = ['#541791', '#07B229', '#D8889B', '#002940', '#6C3C11'];

const styles = {

  wrapper: {
    backgroundColor: '#485465',
    border: 'none',
    display: 'flex'
  },

  toolTipContent: {
    color: '#FFFFFF',
    fontFamily: 'Muli',
    fontSize: '12px',
    paddingLeft: '5px',
    paddingTop: '10px'
  },

  label: {
    fontSize: '11px'
  },
  title: {
    fontSize: '16px',
    color: '#485465'
  },
  tooltipContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row'
  },
  toolTip: {
    height: '50px',
    width: '151px',
    opacity: 0.9,
    borderRadius: '2px',
    backgroundColor: '#485465'
  }

}



// WEBPACK FOOTER //
// ./src/components/GraphDistribution/index.jsx